module.exports = __webpack_public_path__ + "static/media/DSC_0872.ed00baa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0872.jpg
// module id = 609
// module chunks = 0